import { render, staticRenderFns } from "./AicaDeArgentina.vue?vue&type=template&id=f4f2d9fc&scoped=true&lang=pug"
import script from "./AicaDeArgentina.vue?vue&type=script&lang=js"
export * from "./AicaDeArgentina.vue?vue&type=script&lang=js"
import style0 from "./AicaDeArgentina.vue?vue&type=style&index=0&id=f4f2d9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f2d9fc",
  null
  
)

export default component.exports